import apiClient from './_axios';

const API_URL = import.meta.env.VITE_API_URL; // or from '@/constants'

interface TableUser {
   name: string;
   email: string;
   password: string;
   confirmPassword: string;
}

export const forgetPassword = async (data: { email: string }) => {
   const response = await apiClient.post('/auth/forget-password', data);
   return {
      status: response.status,
      data: response.data,
   };
};

export const updatePassword = async (data: {
   token: string;
   userId: string;
   password: string;
}) => {
   const response = await apiClient.post('/auth/update-password', data);
   // console.log(`response--`, response);
   return {
      status: response.status,
      data: response.data,
   };
};

export const signUp = async (data: TableUser) => {
   const response = await apiClient.post('/auth/create', data);
   return {
      status: response.status,
      data: response.data,
   };
};

export const verifyEmail = async (data: { token: string; userId: string }) => {
   const response = await apiClient.post('/auth/verify-email', data);
   return {
      status: response.status,
      data: response.data,
   };
};

export const resendVerificationOTP = async (userId: string) => {
   const response = await apiClient.post('/auth/re-verify-email', { userId });
   return response.data;
};

export const signIn = async (data: { email: string; password: string }) => {
   const response = await apiClient.post('/auth/signin', data);
   // console.log(`response--`, response);

   return {
      status: response.status,
      data: response.data,
   };
};

/** STAGING ONLY: one click signs in the plain test account (the staging server knows which; prod answers 404). */
export const signInStagingTest = async () => {
   const response = await apiClient.post('/auth/staging-test-signin');
   return { status: response.status, data: response.data };
};

export const signInGoogle = async (data: {
   idToken: string;
   referralCode?: string;
}) => {
   const response = await apiClient.post('/auth/signin-google', data);
   return {
      status: response.status,
      data: response.data,
   };
};

export const getProfile = async () => {
   const response = await apiClient.get('/auth/is-auth');
   return {
      status: response.status,
      data: response.data,
   };
};

